import { cn } from '@/shared/lib/utils';
import { useScrollSpy } from '@/shared/hooks/use-scrollspy';

interface ScrollSpyProps {
  categories: string[];
  activeCategory?: string;
  onSetActive?: (category: string) => void;
  className?: string;
}

export function ScrollSpy({ categories, activeCategory, onSetActive, className }: ScrollSpyProps) {
  const { scrollToCategory, scrollSpyRef } = useScrollSpy({
    categories,
    activeCategory,
    onSetActive,
    topOffset: 250,
    bottomOffset: 200,
    debounceMs: 100,
  });

  return (
    <div
      ref={scrollSpyRef}
      className={cn(
        'sticky hide-scrollbar top-0 left-0 right-0 z-40 bg-white',
        'flex gap-2 overflow-x-auto scrollbar-hide',
        'touch-pan-x', // Melhora o scroll no mobile
        className
      )}
    >
      {categories.map(category => {
        const isActive = activeCategory === category;

        return (
          <button
            key={category}
            data-category={category}
            onClick={() => scrollToCategory(category)}
            className={cn(
              'whitespace-nowrap px-4 py-1.5 text-night font-medium transition-colors cursor-pointer',
              'flex-shrink-0', // Evita que os botões encolham no mobile
              'touch-manipulation', // Melhora a responsividade do toque
              isActive && 'border-b-2 border-primary'
            )}
          >
            <span className={cn('text-xs font-bold', isActive ? 'text-primary' : 'text-night')}>
              {category}
            </span>
          </button>
        );
      })}
    </div>
  );
}
